import { Injectable, inject } from "@angular/core"
import { BehaviorSubject } from "rxjs"
import { ApiService } from "./api.service"
import { Availability } from "../meta/Availabilty.interface"
import { MessageService } from "primeng/api"

@Injectable({
  providedIn: "root"
})
export class AvailabilityService {
  private readonly apiService = inject(ApiService)
  private readonly messageService = inject(MessageService)

  private readonly _isBusy$ = new BehaviorSubject<boolean>(false)
  public readonly isBusy$ = this._isBusy$.asObservable()

  private readonly _availability$ = new BehaviorSubject<Availability | null>(null)
  public readonly availability$ = this._availability$.asObservable()

  public check(postalCode: string, city: string, streetName: string, streetNumber: string): void {
    this._isBusy$.next(true)
    this.apiService.fetchAvailability(postalCode, city, streetName, streetNumber).subscribe({
      next: (availability) => {
        if (availability && Array.isArray(availability.availableProducts)) {
          availability.availableProducts = availability.availableProducts.map((product) => ({
            ...product,
            startDate: new Date(product.startDate)
          }))
        }
        this._availability$.next(availability)
        this._isBusy$.next(false)
      },
      error: () => {
        this.messageService.add({ severity: "error", summary: "Fehler", detail: "Verfügbarkeits Prüfung fehlgeschlagen" })
        this._isBusy$.next(false)
      }
    })
  }

  public reset(): void {
    this._availability$.next(null)
  }

  public getAvailability(): Availability | null {
    return this._availability$.getValue()
  }

}
